import { useState } from 'react';

const faqs = [
  {
    category: '利用について',
    items: [
      {
        q: 'どんなペットに対応していますか？',
        a: '現在は犬・猫を中心に対応しています。シッターによって対応可能なペットが異なるため、プロフィールをご確認ください。その他のペットについては、事前にシッターへ直接ご相談いただけます。',
      },
      {
        q: '初めて利用する場合、どうすれば良いですか？',
        a: '1. シッター検索で条件を入力してお気に入りのシッターを探す → 2. シッターのプロフィールを確認 → 3. メッセージを送って相談 → 4. 予約・決済の流れになります。日本語でのやり取りなので安心してご利用いただけます。',
      },
      {
        q: '海外のどの国・都市に対応していますか？',
        a: '現在はオランダとドイツを中心に対応しています。現在EUを中心に展開を少しずつ進めている最中です！',
      },
    ],
  },
  {
    category: '料金・支払い',
    items: [
      {
        q: '料金はどのくらいですか？',
        a: 'シッターが料金を決めています。サービス・都市によって異なりますが、1回の訪問ケアは€20〜€40程度が目安です。各シッターのプロフィールに料金が明記されていますので、ご確認ください。',
      },
      {
        q: '支払い方法は何に対応していますか？',
        a: 'クレジットカード・デビットカード（Visa / Mastercard）に対応予定です。プラットフォーム内での安全な決済となり、シッターへの直接払いは保証対象外となりますのでご注意ください。',
      },
      {
        q: 'キャンセル料はかかりますか？',
        a: 'サービス開始の48時間前までのキャンセルは無料です。24時間を切った場合は料金の50%がキャンセル料として発生します。シッター側の都合でキャンセルとなった場合は全額返金いたします。',
      },
    ],
  },
  {
    category: '安全・保証',
    items: [
      {
        q: 'シッターは本当に信頼できますか？',
        a: 'すべてのシッターは登録時に本人確認書類（パスポート等）の提出が必須です。また、過去の口コミ・評価が公開されているため、他のオーナーの体験を参考にして安心して選べます。',
      },
      {
        q: '万が一トラブルがあった場合はどうなりますか？',
        a: 'プラットフォーム内での予約に限り、PawBridge安心保証が適用されます。ペットのケガ・紛失などのトラブルが発生した場合、サポートチームが日本語で対応します。プラットフォーム外での直接取引は保証対象外です。',
      },
    ],
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<string | null>(null);

  const toggle = (key: string) => {
    setOpenIndex(prev => (prev === key ? null : key));
  };

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-[#EEF4F7]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-xs font-semibold text-[#81D8D0] tracking-widest uppercase mb-3">FAQ</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1B2A4A]">よくある質問</h2>
          <p className="mt-3 text-sm sm:text-base text-[#1B2A4A]/60 max-w-lg mx-auto">
            ご不明な点はお気軽にお問い合わせください
          </p>
        </div>

        <div className="space-y-8">
          {faqs.map((group) => (
            <div key={group.category}>
              <div className="flex items-center gap-3 mb-4">
                <div className="h-px flex-1 bg-[#D4E8EC]"></div>
                <span className="text-xs font-semibold text-[#81D8D0] tracking-widest uppercase whitespace-nowrap px-1">
                  {group.category}
                </span>
                <div className="h-px flex-1 bg-[#D4E8EC]"></div>
              </div>

              <div className="space-y-3">
                {group.items.map((item, i) => {
                  const key = `${group.category}-${i}`;
                  const isOpen = openIndex === key;
                  return (
                    <div
                      key={key}
                      className={`bg-white rounded-2xl overflow-hidden transition-all duration-200 ${isOpen ? 'ring-1 ring-[#81D8D0]/40' : ''}`}
                    >
                      <button
                        onClick={() => toggle(key)}
                        className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-4 sm:py-5 text-left cursor-pointer group"
                      >
                        <span className="text-sm sm:text-base font-semibold text-[#1B2A4A] group-hover:text-[#81D8D0] transition-colors leading-snug">
                          {item.q}
                        </span>
                        <span
                          className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${isOpen ? 'bg-[#81D8D0] text-white rotate-45' : 'bg-[#EEF4F7] text-[#1B2A4A]/50'}`}
                        >
                          <i className="ri-add-line text-base"></i>
                        </span>
                      </button>

                      <div
                        className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}
                      >
                        <div className="px-5 sm:px-6 pb-5 sm:pb-6">
                          <div className="h-px bg-[#EEF4F7] mb-4"></div>
                          <p className="text-sm text-[#1B2A4A]/65 leading-relaxed">{item.a}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-white rounded-2xl p-6 sm:p-8">
          <p className="text-sm sm:text-base text-[#1B2A4A]/70 mb-4">
            上記で解決しない場合は、日本語サポートへご連絡ください
          </p>
          <a
            href="mailto:support@pawbridge.com"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#EEF4F7] text-[#1B2A4A] text-sm font-semibold rounded-full hover:bg-[#D4F0ED] hover:text-[#3AADA5] transition-all whitespace-nowrap"
          >
            <i className="ri-mail-line text-base"></i>
            お問い合わせ
          </a>
        </div>
      </div>
    </section>
  );
}
